import './banner-reel.scss';

/**
 * version    1.0
 * class      <type> (BannerReel)
 * classdesc  Banner reel: contains 2, 3 or 4 column with image
 */
export class BannerReel {}
